<template>
    <footer class="h-c-footer h-c-footer--robust h-has-social">
        <section class="h-c-footer__upper">
            <section class="h-c-social">
<!--                <p class="h-c-social__title h-c-social__title&#45;&#45;inline">-->
<!--                    © 2024 北京粒子企业管理有限公司  京ICP备14033608号-3-->
<!--                </p>-->
                <h3 class="h-c-social__title h-c-social__titl gmp-section-header--center" @click="toWeb">
                    © 2024 北京粒子企业管理有限公司  京ICP备14033608号-3
                </h3>

            </section>

        </section>
    </footer>
</template>

<script>
    export default {
        name: "Footer",
        methods:{
            toWeb(){
                window.location.href = 'https://beian.miit.gov.cn/#/Integrated/index';
            }
        }
    }
</script>

<style lang="less">
    @import "/myless/variables";

    .h-c-footer__upper {
        margin: 0 auto;
        padding: 30px 16px 0;
        @media (min-width: @screen-600-min) {
            display: flex;
            flex-wrap: wrap;
            max-width: 1344px;
            padding: 30px 32px 0;
        }
    }

    .h-c-social {
        max-width: 100%;
        @media (min-width: @screen-600-min) {
            flex: 1 0 auto;
            display: flex;
            flex-wrap: wrap;
        }
    }

    .h-c-footer .h-c-social {
        margin: -10px 0 20px;
    }

    .h-c-social__group {
        -ms-flex: 0 0 100%;
        flex: 0 0 100%;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
        margin: 0;
        @media (min-width: @screen-600-min) {
            flex-wrap: nowrap;
            padding-right: 70px;
        }
    }


    .h-c-social__title {
        color: #202124;
        -ms-flex: 0 0 100%;
        flex: 0 0 100%;
        font-family: "Google Sans",Roboto,Arial,Helvetica,sans-serif;
        font-size: 14px;
        font-weight: 400;
        letter-spacing: .75px;
    }

    .h-c-social__title.h-c-social__title--inline {
        line-height: 3.14286;
        -ms-flex: 0 0 auto;
        flex: 0 0 auto;
        margin-right: 24px;
        @media (min-width: @screen-600-min) {
              margin-right: 32px;
        }
    }

    ul.h-no-bullet {
        margin-left: 0;
    }
    .h-c-footer .h-c-social__list {
        margin: 0 -10px;
    }

    .h-c-social__item {
        flex: 0 0 auto;
        float: left;
        height: 44px;
        margin: 0 10px 0 0;
        width: 44px;
    }

    .h-c-social__item .h-c-social__link {
        border-radius: 50%;
        display: block;
        height: 44px;
        padding: 10px;
        width: 44px;
    }







</style>